export function isNonEmptyString(str?: string | null): str is string {
   return typeof str === "string" && str.length > 0;
}
